// _components/onboarding/consultation/ConsultStep2.tsx
import { motion } from "framer-motion";
import Image from "next/image";
import { useState } from "react";

type Step2Props = {
  onBack: () => void;
  onNext: (data: any) => void;
  progressBar?: React.ReactNode;
};

export default function ConsultStep2({ onBack, onNext, progressBar }: Step2Props) {
  const [selected, setSelected] = useState<string | null>(null);

  const options = [
    { id: "home", label: "Home", icon: "/assets/icons/home.svg" },
    {
      id: "business",
      label: "Business",
      icon: "/assets/icons/solar-buildings.svg",
    },
    {
      id: "recycle",
      label: "Recycle Components",
      icon: "/assets/icons/recycle.svg",
    },
  ];

  return (
    <div className="text-center ">
      <motion.h1
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-3xl font-semibold text-gray-800"
      >
        What do you want to power?
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="mt-2 text-sm text-gray-600"
      >
        Tell us your goal (e.g: powering your home, running a business, or recycling
        old solar parts)
      </motion.p>

      {progressBar}

      <div className="mt-8 space-y-4">
        {options.map((item) => (
          <motion.button
            key={item.id}
            whileTap={{ scale: 0.98 }}
            whileHover={{ scale: 1.01 }}
            onClick={() => setSelected(item.id)}
            className={`w-full flex items-center justify-between p-4 rounded-xl border-2 transition-colors ${selected === item.id
                ? "border-green-700 bg-green-50"
                : "border-gray-200 hover:border-gray-300"
              }`}
          >
            <div className="flex items-center space-x-5">
              <Image
                src={item.icon}
                alt={item.label}
                width={24}
                height={24}
                className="w-6 h-6"
              />
              <span className="text-lg font-medium text-gray-800">
                {item.label}
              </span>
            </div>
            <div
              className={`h-6 w-6 rounded-full border-2 flex items-center justify-center ${selected === item.id ? "border-green-600" : "border-gray-300"
                }`}
            >
              {selected === item.id && (
                <div className="h-3 w-3 rounded-full bg-green-600"></div>
              )}
            </div>
          </motion.button>
        ))}
      </div>

      <div className="mt-10 flex justify-end gap-6">
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-full border border-gray-300 text-gray-700 font-medium hover:bg-gray-100"
        >
          ← Back
        </button>
        <motion.button
          whileTap={{ scale: 0.95 }}
          disabled={!selected}
          onClick={() => onNext({ goal: selected })}
          className={`px-6 py-3 rounded-full font-medium ${selected
              ? "bg-green-800 text-white hover:bg-green-700"
              : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
        >
          Continue
        </motion.button>
      </div>
    </div>
  );
}
